import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../shared/Notification';
import NavHeader from './NavHeader';
import { GoogleLogin } from "@react-oauth/google";
import styles from './login.module.css';
import Footer from '../shared/Footer';

const LoginApplicant = () => {
    const [formData, setFormData] = useState({ emailOrPhone: '', password: '' });
    const [error, setError] = useState('');
    const [notification, setNotification] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const message = localStorage.getItem('notification');
        if (message) { setNotification(message); localStorage.removeItem('notification'); }

        // if (localStorage.getItem('token')) navigate('/');
    }, []);

    const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post('/api/authApplicant/login', formData);
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('notification', 'Successfully logged in!');
            navigate('/');
        } catch (error) {
            // console.error('Login error:', error.response?.data?.message || error.message);
            setError(error.response?.data?.message || 'An error occurred');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        <NavHeader />
        {notification && <Notification message={notification} onClose={() => setNotification('')} />}

        <div className={styles.loginPage}>
            <div className={styles.card}>

                <div className={styles.cardHeader}>
                    <h1 className={styles.welcome}>Welcome back 👋</h1>
                    <p className={styles.subtext}>Log in to continue learning & teaching.</p>
                </div>

                <div className={styles.cardBody}>

                    <div className={styles.googleWrapper}>
                        <GoogleLogin
                            onSuccess={async (credentialResponse) => {
                                try {
                                    const res = await axios.post("/api/authApplicant/google", { credential: credentialResponse.credential });
                                    localStorage.setItem("token", res.data.token);
                                    navigate("/");
                                } catch (err) {
                                    const msg = err.response?.data?.message || "Google Login Failed";
                                    setError(msg); setNotification(msg);
                                }
                            }}
                            onError={() => { setError("Google Login Failed"); setNotification("Google Login Failed"); }}
                            size="large"
                            text="continue_with"
                            theme="outline"
                            shape="rectangular"
                            // width="348"
                        />
                    </div>

                    <div className={styles.divider}>
                        <div className={styles.dividerLine}></div>
                        <span className={styles.dividerText}>or continue with email</span>
                        <div className={styles.dividerLine}></div>
                    </div>

                    <form onSubmit={handleSubmit} className={styles.loginForm}>
                        <div className={styles.fieldGroup}>

                            <div className={styles.fieldWrap}>
                                <span className={styles.fieldIcon}>✉</span>
                                <input
                                    className={styles.input}
                                    type="text"
                                    name="emailOrPhone"
                                    placeholder="Email or phone number"
                                    value={formData.emailOrPhone}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className={styles.fieldWrap}>
                                <span className={styles.fieldIcon}>🔒</span>
                                <input
                                    className={styles.input}
                                    type={showPassword ? "text" : "password"}
                                    name="password"
                                    placeholder="Password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    required
                                />
                                {/* <button
                                    type="button"
                                    className={styles.eyeBtn}
                                    onClick={() => setShowPassword(!showPassword)}
                                >
                                    {showPassword ? '👁️' : '👁️‍🗨️'}
                                </button> */}
                            </div>

                        </div>

                        <div className={styles.forgotLink}>
                            <a href="/forget-password">Forgot password?</a>
                        </div>

                        {error && <div className={styles.errorMsg}>{error}</div>}

                        <button type="submit" className={styles.submitBtn} disabled={loading}>
                            {loading ? 'Logging in…' : 'Log in →'}
                        </button>
                    </form>

                </div>

                <div className={styles.cardFooter}>
                    Don't have an account? <a href="/signup">Sign up free</a>
                </div>

            </div>
        </div>
        <Footer />
        </>
    );
};

export default LoginApplicant;